<template>
    <div>
        <x-header style="background: #F4F4F4" :left-options="{backText: ''}" />
        <h5 title="topic" style="text-align: center; padding: 20px 20px 0px 5px">「精明用家熱購(亦稱 KOL 熱購)」的網購條款</h5>
        <div style="padding: 20px">
        <p title="Introduction">請客人務必於提交訂單前詳細閲讀以下「精明用家熱購條款(KOL 熱購條款)」(下簡
            稱“本條款”),一經提交訂單,即表示客人完全明白同意並接受所有條款:</p>
        <br>
        <p title="First">第一條 定義:
            <br>
            「KOL 熱購」:是指本網購平台,目前主要提供網上銷售服務給中國內地,香港及澳門
            地區的客人,亦稱為「精明用家熱購」,(下簡稱“本平台”)。
            <br>
            「網購產品」是指獲本平台核准銷售之產品及/或服務。
            <br>
            「精明用家」:是指本平台所委託的代表,負責分享網購產品資訊給客人。
            <br>
            「客人」: 是指使用平台訂購網購產品及/或完成交易的顧客。
            <br>
            「貨品」: 是指使用客人透過 KOL 熱購提交訂單所購買網購產品。
            <br>
            「運費」: 是指客人因訂購貨品而所須付的送貨費用。
            <br>
            「KOL 熱購條款」:是指本條款,即關於客人使用本平台時所應根據的規範及守則,亦
            稱為「精明用家熱購條款」。
            <br>
            「原廠產品」:是指完全源自產品製造廠商及/或品牌持有者的非冒牌產品及/或服務。</p>
        <br>
        <p title="Second">第二條 客人訂購前須知:
            <br>
            一、本平台以嚴謹的態度盡力以一切可行措施確保所有上架的網購產品資訊的準確
            性,保證百分百全新原廠產品(除特別標明外),客人如果對其準備訂購的網購產品存
            有任何疑問,請客人不應提交訂單,以避免不必要的爭議。
            <br>
            二、本平台上網購產品的照片所顯示的效果或色差等等,或會因不同手機或電腦的解
            析度而有所不同,一經完成交易後,客人不得以此理由換貨或退款。
            <br>
            三、有折扣的網購產品或會存在微瑕疵等等小問題,本平台保留對該等微瑕疵等問題
            的解釋權,客人亦不得以此理由換貨或退款。
            <br>
            四、本平台有權因應實際情況而對本條款及/或網購產品資訊不時有所更改/更新,客人
            每次下單前應特別留意該等更改/更新。
            <br>
            五、客人一經提交訂單後,不能更改已下單的產品或數量。
            <br>
            六、本平台有權在無需任何解釋的情況下,不接受任何客人的訂單。
            <br>
            七、若個別網購產品帶有保養,將由有關的供應商直接提供。</p>
        <br>
        <p title="Third">第三條 網購產品送貨方法:
            <br>
            一、客人必須明白來自全球不同國家的貨期有早有遲,貨運或會偶然受到供應商,物
            流公司或海關等等因素影響物流速度而導致延誤 ,本平台會盡力協調,但亦不擔保完
            全沒有延遲之風險。欲急於收貨的客人請于提交訂單前謹慎考慮,恕本平台不接受急
            單。
            <br>
            二、客人若登入本平台的中國地區網頁訂購網購產品,貨品只能付運中國地區(不包
            括香港及澳門),不論產品數量及重量,均需就每一訂單或送貨繳付運費。客人亦可將
            一張訂單拆分為多於一次送貨,但須為每次送貨繳付運費。於中國地區,貨品將會送
            到客人訂購時輸入的地址。客人須受有關速遞公司的有關條款約束。
            <br>
            三、若客人登入本平台的香港或澳門地區網頁訂購網購產品,貨品只能付運香港或澳
            門地區,購買的貨價港幣 300 元以下者,需就每一訂單或送貨繳付運費。購買的貨價
            達港幣 300 元或以上者,單一送貨可免運費。客人亦可將一張訂單拆分為多於一次送
            貨,但須為每次送貨繳付運費。於香港或澳門地區,貨品將會透過速遞公司送到客人
            訂購時輸入的地址附近的速遞公司自提站或智能櫃,由客人自行領取。客人須受有關
            速遞公司自提站或智能櫃的有關條款約束。
            <br>
            四、若因客人提供的送貨資料/地址錯誤、或物流/速遞公司多次聯絡客人失敗、或客人
            無理拒收貨、或客人逾時不取件、或其他原因而導致送貨失敗或貨品退回,當中產生
            的額外運費及/或安排第二次送貨運費及/或物流公司罰款或稅費等等,一概需由客人負
            責支付。
            <br>
            五、若因特殊原因影響送貨安排的情況,比如體積較大而未能放入智能櫃的貨品,或
            客人大量訂購貨品等等原因,客人須與本平台另行商討作送貨安排。</p>
        <br>
        <p title="Fourth">第四條 付款方法:
            <br>
            一、客人確認訂單前,本平台將會詳細列出選購的產品、數量、顏色等等資料,客人
            須確認並轉到結算網頁付款,客人所需繳交的款項將包括貨款,運費,稅款及其他
            (若有)費用,目前本平台只接受客人以微信支付方法付款或客人將款項存入本平台
            指定的銀行戶口並將入數紙上傳給本平台。日後本平台增加其他付款辦法,將另行通
            告。
            <br>
            二、客人付款後即表示完成提交訂單,隨即會收到本平台發出的訂單編號。若有需
            要,客人可根據該訂單編號隨時向本平台的客戶服務部門(下簡稱“客服”)查詢。</p>
        <br>
        <p title="Fifth">第五條 換貨/退款方法:
            <br>
            一、若客人收貨後發現有以下本條第二款所列的問題,可於收貨後的 3 天內申請換貨
            或退款。
            <br>
            二、本平台僅接受處理以下情況的換貨或退款申請:客人收到的貨品與訂購貨品不相
            符;或客人收到的貨品有品質或損壞問題。
            <br>
            三、本平台並不接受上述第二款以外的其他貨品的問題,包括但不限於:個人原因
            (如買錯貨,買錯顏色 或個人喜好不合用等)、由客人自行到供應商即時驗收並
            提貨的貨品、收貨超過 3 天或以上的貨品、經客人修改過或使用過貨品後出現的
            問題、部分在本平台已經標明不能退貨的網購產品、因手機/電腦的解析度有所不
            同而引致貨品實物與照片的效果差別或色差、或存在微瑕疵的折扣網購產品、因
            貨品運送過程中的任何損毀(本平台可協助客人追討送貨公司或供應商)、客人退
            還貨品的包裝及配件與收貨時不一致;及其他非關本平台/供應商或物流公司的過
            失所引致的貨品問題。
            <br>
            四、若因上述第二款的原因而客人選擇換貨或退款,客人必須先向本平台客服申請
            (客人須先拍下有關貨品照片並上傳給客服),待客服確認後客人再將貨品連同所
            有包裝及配件完全密封,自費郵寄或速遞到本平台客服指定的地址。若在客服確
            認前寄出貨品,本平台有權不接受客人申請。
            <br>
            五、若因上述第二款的原因而客人申請換貨獲確認受理,客服在收到退回貨品後,會
            儘快安排送出新貨給客人。但若貨品暫時供應缺貨,客人可選擇申請退款。
            <br>
            六、若因上述第二款或第五款的原因而客人申請退款獲確認受理,客服在收到退回貨
            品後,於 10 個工作天內將客人提交訂單時所付的貨價及運費退回給客人。
            <br>
            七、貨品如在客人退回貨品期間有損壞或遺失,本平台恕不負責。
            <br>
            八、所有換貨/退款條款,本平台有權適時作出修改,客人必須保持留意有關條款。本
            平台有權拒絕客人換貨/退款的權利,如有任何爭議,本平台保留最終決定權。</p>
        <br>
        <p title="Sixth">第六條 不可抗力:
            本平台將不負責因超出其合理掌控範圍之偶發事件而引致客人的一切損失,該等事件
            包括但不限於天災;暴動;火災;爆炸;水災;無法取得燃料、電力、原料、貨櫃或
            運輸設備;意外;機器或器材故障;勞工糾紛或短缺;國防要求或政府之法令規章
            (無論其是否有效,其中包含但不限於優先權、徵收、分配或價格調整限制)。</p>
            <br>
        <p title="Seventh">第七條 私隱政策聲明:
            本平台尊重任何客人的私隱權。本平台會確保所收集、傳送、儲存及使用的客人個人
            資料將遵照政府的有關私隱法例的規定處理。若客人提供個人資料予本平台,則被視
            作同意此私隱政策。</p>
        <br>
        <p title="Eighth">第八條 其他:
            一、本平台暫只接受客人登入中國,中國香港及中國澳門地區提交訂單,若日後營運
            加入其他地區,將會另作通告。本平台網購產品銷售受香港地區的法律約束,若客人
            是登入中國或澳門地區帳戶提交訂單(即訂購貨品送貨到中國或澳門,屬跨境進口貨
            品,見上述第三條),該客人亦須理解其網購行為將同時受其地區的有關法律約束。
            <br>
            二、若客人被發現有任何可疑,不誠實,誤導或欺詐行為,本平台有權即時暫停或甚
            至終止該客人的帳戶,同時一律報警處理。
            <br>
            三、客人明白並接受于其成功訂購網購產品後,分享產品資訊給該客人的精明用家可
            獲 KOL 熱購給予某比例的積分作為獎勵。
            四、本平台會不定時監察並對本精明用家熱購條款作出適當修訂及優化,客人必須保
            持留意有關條款,客人不得以此為藉口提出異議或申請換貨/退貨。客人若對本條款有
            任何異議,請客人不要提交訂單,以避免不必要的爭議。一經提交訂單,即表示客人
            完全明白同意並接受所有條款。</p>
        </div>
    </div>
</template>
<script>
import { XHeader } from 'vux'
export default {
    components: {
        XHeader
    }
}
</script>




// WEBPACK FOOTER //
// src/components/TermsAndConditions.vue